<template>
  <div v-html="report"></div>
</template>
<style scoped>
div >>> h2 {
  color: rgb(160, 44, 15);
}
div >>> table {
  border: 0px solid black;
}
div >>> td {
  border: 0px solid black;
}
div >>> table {
  width: 75%;
}
div >>> th {
  height: 25px;
}
</style>

<script>
import { mapGetters } from "vuex";
import { reportService } from "@/services/report";

export default {
  name: "report-view",
  data() {
    return {
      report: "loading..."
    };
  },
  computed: {
    ...mapGetters(["activeAddress"])
  },
  methods: {
    retrieveReport() {
      const id = this.activeAddress.uniqueIdAddress;

      reportService
          .requestHTML(id)
          .then(response => (this.report = response.data))
          // eslint-disable-next-line
          .catch(() => console.log("Error!"))
    }
  },
  created() {
    this.retrieveReport();
  }
};
</script>

